module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAAAXNSR0IArs4c6QAAAFpJREFUCB1jZGBg2ArE/EAcCMSvgRgZiAI564H4I0jwCBD/B+IrQAySgAEQGyQGkgOpAUvCBGCKkRXBxEBqURRfB/JBGJstILUoinEqAqsEEmJA/BaKkd3LAABjkBoEb5bx6gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_down-black.png
// module id = 96
// module chunks = 0